import ReactModal from 'react-modal';

import { CrossIcon } from '../svg/CrossIcon';

export const Modal = ({
  testPrefix = '',
  isClosable = true,
  isModalOpen,
  closeModal,
  children,
}: {
  closeModal?: () => void;
  isModalOpen: boolean;
  children: React.ReactElement;
  testPrefix: string;
  isClosable: boolean;
}) => {
  return (
    <ReactModal
      className="absolute inset-[50%_auto_auto_50%] max-h-[96vh] min-w-[310px] max-w-[1120px] -translate-x-1/2 -translate-y-1/2 rounded-xs bg-white shadow-modal outline-none"
      overlayClassName="fixed z-[15] inset-0 bg-overlay-decision-modal"
      isOpen={isModalOpen}
      shouldCloseOnOverlayClick={isClosable}
      onRequestClose={closeModal}
      ariaHideApp={false}
    >
      <div
        data-testid={`${testPrefix}Modal`}
        className="px-[14px] py-[25px] m900:px-[40px] m900:py-[32px]"
      >
        {isClosable && (
          <CrossIcon
            className="absolute right-0 top-l h-xl w-xl cursor-pointer fill-denim-25"
            onClick={closeModal}
            data-testid={`${testPrefix}Close`}
          />
        )}
        {children}
      </div>
    </ReactModal>
  );
};
